// shared-components/index.js

// Import and re-export all components explicitly
import { CompudoptLogo, Header, NavCard, PrimaryButton, SecondaryButton, GhostButton, QuickSelectButton, TertiaryButton, IconButton, ToggleButton, DeadendEscapeButton, DigitalLiteracyClasses } from './components';

export { CompudoptLogo, Header, NavCard, PrimaryButton, SecondaryButton, GhostButton, QuickSelectButton, TertiaryButton, IconButton, ToggleButton, DeadendEscapeButton, DigitalLiteracyClasses };

// Export AI services (commented out - not used in web-helper)
// export { getAIResponse, parseFunctionCalls } from './src/services/SimpleAIService';

// Translations embedded to avoid JSON bundling issues
export const enTranslations = {
  "app": {
    "title": "Compudopt Helper",
    "loading": "Loading...",
    "error": "Something went wrong",
    "retry": "Try Again",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "cancel": "Cancel",
    "save": "Save",
    "confirm": "Confirm",
    "ok": "OK"
  },
  "navigation": {
    "home": "Home",
    "settings": "Settings",
    "support": "Support",
    "help": "Help"
  },
  "onDevice": {
    "wifi": "Wi-Fi Connection",
    "wifiDesc": "Connect to internet and troubleshoot network issues",
    "power": "Power & Charging",
    "powerDesc": "Check battery status and charging health",
    "display": "Display & Audio",
    "displayDesc": "Adjust brightness, volume, and accessibility",
    "usb": "USB Resources",
    "usbDesc": "Access offline learning materials from USB",
    "contact": "Contact Support",
    "contactDesc": "Get help from the Compudopt team",
    "systemSettings": "Settings",
    "systemSettingsDesc": "Language, startup, and system preferences"
  },
  "web": {
    "library": "Learning Library",
    "libraryDesc": "Browse courses, videos, and interactive lessons",
    "liveSupport": "Live Support",
    "liveSupportDesc": "Chat with our team in real-time",
    "community": "Community",
    "communityDesc": "Connect with other learners and share tips",
    "progress": "My Progress",
    "progressDesc": "View your learning journey and achievements",
    "account": "My Account",
    "accountDesc": "Manage profile, devices, and preferences",
    "notifications": "Notifications",
    "notificationsDesc": "Updates, announcements, and reminders"
  },
  "handoff": {
    "openOnWeb": "Open on Web",
    "openOnDevice": "Open on Device",
    "continueOnline": "Continue Online",
    "returnToDevice": "Return to Device Helper",
    "exploreOnline": "Explore More Online",
    "accessFullLibrary": "Access full learning library, live support, and community forums",
    "needSystemHelp": "Need System Help?",
    "openDeviceHelper": "Open the on-device helper for WiFi, battery, and system settings"
  },
  "welcome": {
    "onDevice": "Welcome to your Compudopt computer!",
    "onDeviceSubtitle": "I'm here to help you get started and solve any problems.",
    "web": "Welcome back!",
    "webSubtitle": "Continue learning and connect with the Compudopt community."
  },
  "status": {
    "online": "Online",
    "offline": "Offline",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "connecting": "Connecting...",
    "error": "Error"
  }
};

export const esTranslations = {
  "app": {
    "title": "Asistente Compudopt",
    "loading": "Cargando...",
    "error": "Algo salió mal",
    "retry": "Intentar de Nuevo",
    "close": "Cerrar",
    "back": "Atrás",
    "next": "Siguiente",
    "cancel": "Cancelar",
    "save": "Guardar",
    "confirm": "Confirmar",
    "ok": "OK"
  },
  "navigation": {
    "home": "Inicio",
    "settings": "Ajustes",
    "support": "Soporte",
    "help": "Ayuda"
  },
  "onDevice": {
    "wifi": "Conexión Wi-Fi",
    "wifiDesc": "Conectar a internet y resolver problemas de red",
    "power": "Energía y Carga",
    "powerDesc": "Verificar estado de batería y salud de carga",
    "display": "Pantalla y Audio",
    "displayDesc": "Ajustar brillo, volumen y accesibilidad",
    "usb": "Recursos USB",
    "usbDesc": "Acceder a materiales de aprendizaje sin conexión",
    "contact": "Contactar Soporte",
    "contactDesc": "Obtener ayuda del equipo Compudopt",
    "systemSettings": "Configuración",
    "systemSettingsDesc": "Idioma, inicio y preferencias del sistema"
  },
  "web": {
    "library": "Biblioteca de Aprendizaje",
    "libraryDesc": "Explorar cursos, videos y lecciones interactivas",
    "liveSupport": "Soporte en Vivo",
    "liveSupportDesc": "Chatear con nuestro equipo en tiempo real",
    "community": "Comunidad",
    "communityDesc": "Conectar con otros estudiantes y compartir consejos",
    "progress": "Mi Progreso",
    "progressDesc": "Ver tu viaje de aprendizaje y logros",
    "account": "Mi Cuenta",
    "accountDesc": "Administrar perfil, dispositivos y preferencias",
    "notifications": "Notificaciones",
    "notificationsDesc": "Actualizaciones, anuncios y recordatorios"
  },
  "handoff": {
    "openOnWeb": "Abrir en Web",
    "openOnDevice": "Abrir en Dispositivo",
    "continueOnline": "Continuar en Línea",
    "returnToDevice": "Volver al Asistente del Dispositivo",
    "exploreOnline": "Explorar Más en Línea",
    "accessFullLibrary": "Acceder a biblioteca completa, soporte en vivo y foros comunitarios",
    "needSystemHelp": "¿Necesitas Ayuda del Sistema?",
    "openDeviceHelper": "Abrir el asistente del dispositivo para WiFi, batería y configuración del sistema"
  },
  "welcome": {
    "onDevice": "¡Bienvenido a tu computadora Compudopt!",
    "onDeviceSubtitle": "Estoy aquí para ayudarte a comenzar y resolver cualquier problema.",
    "web": "¡Bienvenido de nuevo!",
    "webSubtitle": "Continúa aprendiendo y conéctate con la comunidad Compudopt."
  },
  "status": {
    "online": "En línea",
    "offline": "Sin conexión",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "connecting": "Conectando...",
    "error": "Error"
  }
};

export const translations = { en: enTranslations, es: esTranslations };

// Export styles path for importing
export const stylesPath = './styles/tokens.css';
